import styled from 'styled-components';
export const Td = styled.td.withConfig({
  displayName: "StyledComponents__Td",
  componentId: "sc-18yxrlo-0"
})(["position:relative;"]);